export default {
  selectMenu: {
    height: 'none',
  },
};
